<template>
  <div class="componentRoot">
    <LoadingScreenVue v-if="!monthlyData || loading" :loading="true" />

    <v-container fluid v-if="days && !loading" class="pt-0">
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4 pt-2" flat>
            <v-container fluid class="px-2">
              <v-row>
                <v-col class="pa-0" cols="auto"
                  style="display: flex; justify-content: space-between; align-items: center">

                  <v-menu v-model="datePicker" :close-on-content-click="false" transition="v-scale-transition"
                    min-width="auto" location="center" position="absolute">
                    <template v-slot:activator="{ props }">
                      <h3 style="display: flex; justify-content: space-between; align-items: center">
                        <v-icon @click="gotoMonth(-1)">mdi-chevron-left</v-icon>
                        <span v-bind="props">{{ $t("constants.month_" + currDate.getMonth()) }} {{
                          currDate.getFullYear()
                        }}</span>
                        <v-icon @click="gotoMonth(1)">mdi-chevron-right</v-icon>
                      </h3>
                    </template>

                    <v-date-picker v-model="pickerDate" v-if="datePicker" color="rgb(var(--v-theme-primary))"
                      :show-week="true" hide-header :show-adjacent-months="true" @update:modelValue="
                        datePicker = false;
                      selectDate();
                      " />
                  </v-menu>

                </v-col>
                <v-spacer />
                <v-col cols="auto" class="pr-0">
                  <v-card @click="switchShowHoliday($event)" flat class="red-background pa-2 text-center"
                    :class="{ 'gray-background': !showHoliday }">
                    <v-container fluid class="pa-0">
                      <v-row>
                        <v-col cols="auto" :class="{ 'icon-transparency': !showHoliday }">
                          {{ $t("basics.holiday") }}
                        </v-col>
                        <v-spacer />
                        <v-divider vertical thickness="2" class="my-2"
                          v-if="$checkFunctionPermission(['holiday_post_detail'])" />
                        <v-col v-if="$checkFunctionPermission(['holiday_post_detail'])" class="icon-transparency"
                          cols="auto" @click="showEditItem($event, 'holiday')">
                          <v-icon>mdi-plus</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="auto" class="pr-0">
                  <v-card @click="switchShowPTO($event)" flat class="yellow-background pa-2 text-center"
                    :class="{ 'gray-background': !showPTO }">
                    <v-container fluid class="pa-0">
                      <v-row>
                        <v-col cols="auto" :class="{ 'icon-transparency': !showPTO }">
                          {{ $t("basics.pto") }}
                        </v-col>
                        <v-spacer />
                        <v-divider vertical thickness="2" class="my-2"
                          v-if="$checkFunctionPermission(['user_to_date_post_detail'])" />
                        <v-col v-if="$checkFunctionPermission(['user_to_date_post_detail'])" class="icon-transparency"
                          cols="auto" @click="showEditItem($event, 'pto')">
                          <v-icon>mdi-plus</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="auto">
                  <v-card @click="switchShowBirthday($event)" flat class="light-blue-background pa-2 text-center"
                    :class="{ 'gray-background': !showBirthday }">
                    <v-container fluid class="pa-0">
                      <v-row>
                        <v-col cols="auto" :class="{ 'icon-transparency': !showBirthday }">
                          {{ $t("basics.birthday") }}
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <div class="weekDayContainer">
              <div class="weekdayCol" v-for="(i, index) in 7" :key="i">
                <span v-if="!isMobile">{{ $t("constants.weekday_" + (i % 7)) }} </span>
                <span v-else>{{ $t("constants.weekday_" + (i % 7)).substring(0, 2) }} </span>
              </div>
            </div>

            <div class="">
              <div v-for="(month, monthIndex) in days" :key="monthIndex"
                :style="{ display: type.startsWith('year') ? 'flex' : 'block' }">
                <div class="monthContainer" style="display: flex; flex-direction: column">
                  <div v-for="(i, index) in month.days" class="weekDayContainer">
                    <div class="dayCol" @dragover="setActiveDay(j)" @click="handleClickDate($event, j, false)"
                      @mousedown.middle="handleClickDate($event, j, true)" v-for="(j, index2) in i" :key="j" :class="{
                        'gray-background':
                          (j.month != currDate.getMonth()) || j.gray
                      }">
                      <div>
                        <div style="width: 100%; position: relative" class="text-right">
                          <div style="display: flex; justify-content: space-between">
                            <small><span v-if="type == 'calendar' && index2 == 0">
                                {{ $t("basics.calendarWeek") + getCW(index) }}</span></small>
                            <small v-if="j.date == 1">
                              <span v-if="type == 'calendar'">
                                {{
                                  $t(
                                    "constants.month_" +
                                    (j.month == currDate.getMonth() ? month.month : (month.month + 1) % 12)
                                  ).substring(0, 3)
                                }}
                              </span>
                            </small>
                            <span>
                              {{ j.date }}</span>
                          </div>

                          <v-card v-if="showHoliday" flat v-for="holiday in j.holidays" :key="holiday.holiday.id"
                            :style="{
                              width: holiday.width,
                              opacity: holiday.rendered ? 1 : 0,
                              'z-index': holiday.rendered ? 1 : -1,
                            }" :class="{ hoverable: holiday.rendered }" class="mb-1 red-background holidayCard"
                            style="margin-left: 1px" @click="showEditItem($event, 'holiday', holiday.holiday)">
                            <v-container fluid style="overflow-y: hidden; height: 28px">
                              <v-row>
                                <v-col cols="auto" class="pa-0">
                                  {{ holiday.holiday.comment }}
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>

                          <v-card v-if="showBirthday" flat v-for="birthday in j.birthdays" :key="birthday.id" :style="{
                            width: '100%',
                          }" @click="gotoUser($event, birthday, false)"
                            @mousedown.middle="gotoUser($event, birthday, true)"
                            class="mb-1 light-blue-background birthdayCard hoverable" style="margin-left: 1px">
                            <v-container fluid style="overflow-y: hidden"
                              :style="{ height: birthday.courses ? '56px' : '28px' }">
                              <v-row>
                                <v-col cols="auto" class="pa-0">
                                  {{ birthday.full_name }}
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>

                          <v-card v-if="showPTO" flat v-for="pto in j.ptos" :key="pto.pto.id" :style="{
                            width: pto.width,
                            opacity: pto.rendered ? 1 : 0,
                            'z-index': pto.rendered ? 1 : -1,
                          }" :class="{ hoverable: pto.rendered }" class="mb-1 yellow-background ptoCard"
                            style="margin-left: 1px" @click="showEditItem($event, 'pto', pto.pto)">
                            <v-container fluid style="overflow-y: hidden; height: 28px">
                              <v-row>
                                <v-col cols="auto" class="pa-0"
                                    v-if="pto.pto.stay_available">
                                  <v-tooltip :text="$t('basics.stayAvailable')">
                                    <template v-slot:activator="{ props }">
                                      <v-icon v-bind="props">mdi-import</v-icon>
                                    </template>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="auto" class="pa-0"
                                    v-if="pto.pto.ical_id">
                                  <v-tooltip :text="$t('messages.googleImport')">
                                    <template v-slot:activator="{ props }">
                                      <v-icon v-bind="props">mdi-google</v-icon>
                                    </template>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="auto" class="pa-0">
                                  {{ pto.pto.user.first_name }} {{ pto.pto.user.last_name }}
                                </v-col>
                                <v-spacer />
                                <v-col cols="auto" class="pa-0">
                                  <v-tooltip v-if="pto.pto.comment" :text="pto.pto.comment">
                                    <template v-slot:activator="{ props }">
                                      <div v-bind="props" style="
                                background-color: rgb(var(--v-theme-error));
                                width: 12px;
                                height: 12px;
                                border-radius: 50%;
                              "></div>
                                    </template>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>


    <HolidayEditVue :dayData="activeItem" :refreshDisplay="editDrawer['holiday']" @close="hideEditItem" />
    <PTOEditVue :ptoData="activeItem" :refreshDisplay="editDrawer['pto']" @close="hideEditItem" />
  </div>
</template>

<script>
import HolidayEditVue from "../../../components/calendar/HolidayEdit.vue"
import PTOEditVue from "../../../components/calendar/PTOEdit.vue"

export default {
  name: "monthlyCalendar",

  props: {
    type: {
      default: "calendar",
    },
    refetch: {},
  },

  emits: ["editItem", "loading", "clickDate", "editRessourceItem"],

  data() {
    return {
      currDate: new Date(),
      lastDayOfMonth: undefined,
      lastDayOfLastMonth: undefined,
      firstDayOfMonth: undefined,
      firstWeekdayOfMonth: undefined,
      firstCalendarWeek: undefined,


      activeItem: undefined,
      activeType: undefined,

      editDrawer: {
        holiday: 0,
        pto: 0,
      },

      monthlyData: undefined,

      showHoliday: true,
      showPTO: true,
      showBirthday: true,

      days: [],

      activeDay: undefined,
      activeDragItem: undefined,

      loading: false,

      headerHeight: undefined,


      datePicker: false,
      pickerDate: new Date(),

      colorClasses: [
        "green-background",
        "light-blue-background",
        "red-background",
        "light-blue-background",
        "yellow-background",
      ],
    };
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  },

  components: {
    HolidayEditVue,
    PTOEditVue
  },

  watch: {
    refetch() {
      this.setup();
    },
  },

  methods: {
    showEditItem(event, type, item) {
      event.stopPropagation();
      event.preventDefault();

      if (this.profileView) {
        return;
      }


      if (item) {
        if (type == "pto") {
          if (!this.$checkFunctionPermission(["user_to_date_patch_detail"])) {
            return;
          }
        } else if (type == "holiday") {
          if (!this.$checkFunctionPermission(["holiday_patch_detail"])) {
            return;
          }
        }
      }

      this.activeItem = item;
      this.activeType = type;

      this.editDrawer[type]++;
    },
    hideEditItem(data) {
      for (let i in this.editDrawer) {
        this.editDrawer[i] = 0;
        this.activeItem = undefined;
        this.activeType = undefined;
      }

      if (data) {
        this.fetchData();
      }
    },
    gotoUser(event, user, newTab) {
      event.stopPropagation()
      event.preventDefault()

      if (!this.$checkFunctionPermission(["user_overview_detail", "user_detail"])) {
        return
      }

      if (newTab) {
        window.open(
          "/backoffice/users/" + user.id + "/overview",
          "_blank"
        )
      }
      else {
        this.$router.push(
          "/backoffice/users/" + user.id + "/overview"
        )
      }
    },
    gotoMonth(direction) {
      const date = new Date(this.pickerDate);
      date.setMonth(date.getMonth() + direction);
      date.setDate(1);

      this.pickerDate = date;
      this.updateCurrDate();
      this.setup();
    },

    selectDate() {
      const date = new Date(this.pickerDate);
      date.setDate(1);

      this.pickerDate = date;
      this.updateCurrDate();
      this.setup();
    },

    updateCurrDate() {
      const date = new Date(this.pickerDate);
      this.currDate = date
    },
    getCalendarWeeks(weekIndex, monthIndex) {
      let result = 0

      for (let i = 0; i < monthIndex; i++) {
        result += this.days[i].days.length
      }

      result += weekIndex


      return (result % 52) + 1
    },
    setHeaderHeight() {
      if (this.headerHeight) {
        this.headerHeight = undefined
      }
      else {
        this.headerHeight = "120px !important"
      }
    },
    handleClickDate(event, date, newTab) {
      event.stopPropagation()
      event.preventDefault()

      let dateTemp = date.year + "-" + (date.month + 1) + "-" + date.date

      if (newTab) {
        window.open(
          "/backoffice/calendar/own?date=" + dateTemp, "_blank"
        )
      }
      else {
        this.$router.push(
          "/backoffice/calendar/own?date=" + dateTemp
        )
      }
    },
    getCW(index) {
      return this.firstCalendarWeek + index > 52 ? 1 : this.firstCalendarWeek + index;
    },
    getHolidaysByDay({ date, month, year }, colIndex) {
      let result = [];

      if (!this.monthlyData.holidays) {
        return result
      }

      for (let i = 0; i < this.monthlyData.holidays.length; i++) {
        for (let j = 0; j < this.monthlyData.holidays[i].dates.length; j++) {
          let temp = new Date(this.monthlyData.holidays[i].dates[j]);
          if (temp.getMonth() == month && temp.getDate() == date && temp.getFullYear() == year) {
            let width;
            let factor = this.monthlyData.holidays[i].dates.length - j;
            if (factor > 7 - colIndex) {
              factor = 7 - colIndex;
            }

            width = factor * 100;

            width = "calc(" + width + "% + " + (factor - 1) * 2 + "px)";

            result.push({
              holiday: this.monthlyData.holidays[i],
              rendered: j == 0 || colIndex == 0,
              width: width,
              type: "holiday",
            });
          }
        }
      }

      return result;
    },
    getPTOsByDate({ date, month, year }, colIndex) {
      let result = [];

      if (!this.monthlyData.ptos) {
        return result
      }

      for (let i = 0; i < this.monthlyData.ptos.length; i++) {
        for (let j = 0; j < this.monthlyData.ptos[i].dates.length; j++) {
          let temp = new Date(this.monthlyData.ptos[i].dates[j]);

          if (temp.getMonth() == month && temp.getDate() == date && temp.getFullYear() == year) {
            let width;
            let factor = this.monthlyData.ptos[i].dates.length - j;
            if (factor > 7 - colIndex) {
              factor = 7 - colIndex;
            }

            width = factor * 100;

            width = "calc(" + width + "% + " + (factor - 1) * 2 + "px)";

            result.push({
              pto: this.monthlyData.ptos[i],
              rendered: j == 0 || colIndex == 0,
              width: width,
              type: "pto",
            });
          }
        }
      }

      return result;
    },
    getRTDsByDate({ date, month, year }, colIndex) {
      let result = [];

      if (!this.monthlyData.rtds) {
        return result
      }

      for (let i = 0; i < this.monthlyData.rtds.length; i++) {
        for (let j = 0; j < this.monthlyData.rtds[i].dates.length; j++) {
          let temp = new Date(this.monthlyData.rtds[i].dates[j]);

          if (temp.getMonth() == month && temp.getDate() == date && temp.getFullYear() == year) {
            let width;
            let factor = this.monthlyData.rtds[i].dates.length - j;
            if (factor > 7 - colIndex) {
              factor = 7 - colIndex;
            }

            width = factor * 100;

            width = "calc(" + width + "% + " + (factor - 1) * 2 + "px)";

            let type
            if (this.monthlyData.rtds[i].vehicle != undefined) {
              type = "vehicle"
            }
            else if (this.monthlyData.rtds[i].equipment != undefined) {
              type = "equipment"
            }
            else {
              type = "room"
            }

            result.push({
              rtd: this.monthlyData.rtds[i],
              rendered: j == 0 || colIndex == 0,
              width: width,
              type: type,
            });
          }
        }
      }

      return result;
    },
    getBirthdaysByDay({ date, month }, colIndex) {
      let result = [];

      if (this.monthlyData.birthdays) {
        for (let i = 0; i < this.monthlyData.birthdays.length; i++) {
          let temp = new Date(this.monthlyData.birthdays[i].birthday);

          if (temp.getDate() == date && temp.getMonth() == month) {
            result.push(this.monthlyData.birthdays[i]);
          }

        }
      }

      return result;
    },
    setup() {
      this.loading = true

      this.days = [{ month: 0, days: [] }];

      this.currDate = new Date(this.currDate.getFullYear(), this.currDate.getMonth(), 1);
      this.days[0]["month"] = this.currDate.getMonth()

      this.lastDayOfMonth = new Date(
        this.currDate.getFullYear(),
        this.currDate.getMonth() + 1,
        0
      );



      let weekStartsSunday;

      this.lastDayOfLastMonth = new Date(
        this.currDate.getFullYear(),
        this.currDate.getMonth(),
        0
      );
      this.firstDayOfMonth = new Date(
        this.currDate.getFullYear(),
        this.currDate.getMonth(),
        1
      );
      this.firstWeekdayOfMonth = this.firstDayOfMonth.getDay();

      this.firstCalendarWeek = parseInt(this.$moment(this.firstDayOfMonth).format("W"));

      weekStartsSunday = this.firstWeekdayOfMonth == 0;


      for (let i = 1; i <= this.lastDayOfMonth.getDate(); i++) {
        let temp = i + this.firstWeekdayOfMonth - 2;
        let rowIndex = Math.floor(temp / 7);
        let colIndex = temp % 7;

        if (weekStartsSunday) {
          if (temp < 0) {
            colIndex += 7;
          }

          rowIndex++;
        }

        if (!this.days[0].days[rowIndex]) {
          this.days[0].days[rowIndex] = [];
        }

        this.days[0].days[rowIndex][colIndex] = { date: i, month: this.currDate.getMonth(), year: this.currDate.getFullYear() };
      }

      let temp = 0;
      for (let i = this.days[0].days[0].length - 1; i >= 0; i--) {
        if (!this.days[0].days[0][i]) {
          this.days[0].days[0][i] = {
            date: this.lastDayOfLastMonth.getDate() - temp,
            month: this.lastDayOfLastMonth.getMonth(),
            year: this.lastDayOfLastMonth.getFullYear(),
          };

          temp++;
        }
      }

      temp = 1;
      while (this.days[0].days[this.days[0].days.length - 1].length < 7) {
        this.days[0].days[this.days[0].days.length - 1].push({
          date: temp,
          month: (this.currDate.getMonth() + 1) % 12,
          year: this.currDate.getFullYear(),
        });
        temp++;
      }


      this.fetchData();
    },
    fetchData() {
      this.$emit("loading", true);


      let query = "?year=" + this.currDate.getFullYear() + "&month=" + (this.currDate.getMonth() + 1);
      this.axios
        .get(this.axios.defaults.baseURL + "calendar/calendar/monthly/" + query)
        .then((resp) => {
          this.monthlyData = resp.data;

          this.fillCalendar();
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });

    },
    fillCalendar() {
      //fill in closed days and courses per day
      for (let month = 0; month < this.days.length; month++) {
        for (let rowIndex = 0; rowIndex < this.days[month].days.length; rowIndex++) {
          for (let colIndex = 0; colIndex < this.days[month].days[rowIndex].length; colIndex++) {

            this.days[month].days[rowIndex][colIndex].birthdays = this.getBirthdaysByDay(
              this.days[month].days[rowIndex][colIndex],
              colIndex
            );

            this.days[month].days[rowIndex][colIndex].holidays = this.getHolidaysByDay(
              this.days[month].days[rowIndex][colIndex],
              colIndex
            );


            this.days[month].days[rowIndex][colIndex].ptos = this.getPTOsByDate(
              this.days[month].days[rowIndex][colIndex],
              colIndex
            );

          }

          //problem: courses can overlap in view
          //fix: make course always fill entire row with unrendered ghosts!
          for (let colIndex = 0; colIndex < this.days[month].days[rowIndex].length - 1; colIndex++) {
            //holiday, forward
            for (
              let holidayIndex = 0;
              holidayIndex < this.days[month].days[rowIndex][colIndex].holidays.length;
              holidayIndex++
            ) {
              if (
                !this.days[month].days[rowIndex][colIndex + 1].holidays[holidayIndex] ||
                this.days[month].days[rowIndex][colIndex].holidays[holidayIndex].holiday.id !=
                this.days[month].days[rowIndex][colIndex + 1].holidays[holidayIndex].holiday.id
              ) {
                let temp = JSON.parse(
                  JSON.stringify(this.days[month].days[rowIndex][colIndex].holidays[holidayIndex])
                );
                temp.rendered = false;
                this.days[month].days[rowIndex][colIndex + 1].holidays.splice(holidayIndex, 0, temp);
              }
            }


            //ptos, forward
            for (
              let ptoIndex = 0;
              ptoIndex < this.days[month].days[rowIndex][colIndex].ptos.length;
              ptoIndex++
            ) {
              if (
                !this.days[month].days[rowIndex][colIndex + 1].ptos[ptoIndex] ||
                this.days[month].days[rowIndex][colIndex].ptos[ptoIndex].pto.id !=
                this.days[month].days[rowIndex][colIndex + 1].ptos[ptoIndex].pto.id
              ) {
                let temp = JSON.parse(
                  JSON.stringify(this.days[month].days[rowIndex][colIndex].ptos[ptoIndex])
                );
                temp.rendered = false;
                this.days[month].days[rowIndex][colIndex + 1].ptos.splice(ptoIndex, 0, temp);
              }
            }

          }

          for (let colIndex = this.days[month].days[rowIndex].length - 1; colIndex > 0; colIndex--) {
            //holiday, backwards
            for (
              let holidayIndex = 0;
              holidayIndex < this.days[month].days[rowIndex][colIndex].holidays.length;
              holidayIndex++
            ) {
              if (
                colIndex > 0 &&
                (!this.days[month].days[rowIndex][colIndex - 1].holidays[holidayIndex] ||
                  this.days[month].days[rowIndex][colIndex].holidays[holidayIndex].holiday.id !=
                  this.days[month].days[rowIndex][colIndex - 1].holidays[holidayIndex].holiday.id)
              ) {
                let temp = JSON.parse(
                  JSON.stringify(this.days[month].days[rowIndex][colIndex].holidays[holidayIndex])
                );
                temp.rendered = false;
                this.days[month].days[rowIndex][colIndex - 1].holidays.splice(holidayIndex, 0, temp);
              }
            }



            //ptos, backwards
            for (
              let ptoIndex = 0;
              ptoIndex < this.days[month].days[rowIndex][colIndex].ptos.length;
              ptoIndex++
            ) {
              if (
                colIndex > 0 &&
                (!this.days[month].days[rowIndex][colIndex - 1].ptos[ptoIndex] ||
                  this.days[month].days[rowIndex][colIndex].ptos[ptoIndex].pto.id !=
                  this.days[month].days[rowIndex][colIndex - 1].ptos[ptoIndex].pto.id)
              ) {
                let temp = JSON.parse(
                  JSON.stringify(this.days[month].days[rowIndex][colIndex].ptos[ptoIndex])
                );
                temp.rendered = false;
                this.days[month].days[rowIndex][colIndex - 1].ptos.splice(ptoIndex, 0, temp);
              }
            }
          }
        }
      }

      this.$emit("loading", false);
      this.loading = false
    },
    switchShowHoliday(event) {
      event.stopPropagation();
      event.preventDefault();

      this.showHoliday = !this.showHoliday;
    },
    switchShowPTO(event) {
      event.stopPropagation();
      event.preventDefault();

      this.showPTO = !this.showPTO;
    },
    switchShowBirthday(event) {
      event.stopPropagation();
      event.preventDefault();

      this.showBirthday = !this.showBirthday;
    },
    showEditRessourceItem(event, type, item, date = undefined) {
      event.stopPropagation();
      event.preventDefault();

      let max = 10
      let node = event.srcElement
      while (node && node.classList && max > 0 && !node.classList.contains("calendarcard")) {
        node = node.parentNode
        --max
      }

      this.$emit("editRessourceItem", { type: type, item: item })
    },
    scaleContainer() {
      this.$nextTick(() => {
        try {
          const card = document.getElementById("relativeSibling")
          const container = document.getElementById("fixedHeader")

          container.style.width = card.offsetWidth + "px";
        }
        catch (e) {
          console.log(e)
        }
      });
    },
    setActiveDay(day) {
      this.activeDay = day
    }
  },

  mounted() {
    this.setup();

    window.addEventListener("resize", this.scaleContainer);
  },

  unmounted() {
    window.removeEventListener("resize", this.scaleContainer);
  }
};
</script>

<style scoped>
.weekDayContainer {
  display: flex;
  flex-grow: 1;
  width: 100%;
  text-align: center;
}


.dayCol {
  width: 14.2857% !important;
  border: 1px solid rgb(var(--v-theme-background));
  min-height: 150px;
  background-color: rgb(var(--v-theme-light));
}

.dayCol.yearly {
  width: calc(14.2857% - 2px) !important;
}

.invertedMonthBackground.dayCol {
  background-color: rgb(var(--v-theme-background)) !important;
  border: 1px solid rgb(var(--v-theme-light)) !important;
}

.dayCol>div {
  display: flex;
  justify-content: space-between;
}

.dayCol small {
  opacity: 0.5;
  text-transform: uppercase;
}

.weekdayCol {
  width: 14.2857% !important;
  border: 1px solid rgb(var(--v-theme-background));
}


.dayCol:hover {
  background-color: rgba(var(--v-theme-primary), 0.3) !important;
}
</style>
